import { c as _c } from "react/compiler-runtime";
// Tells people when their browser lacks what the layout relies on (it still works, effects degrade).
// One line, dismissible, remembered per missing-feature set (POC #support).
import { useState } from "react";
import { LinkButton } from "./link-button";
const NEED: Record<string, string> = {
  "scroll animations": "animation-timeline: scroll()",
  "container units": "width: 1cqw",
  ":has()": "selector(:has(a))",
  "backdrop blur": "(backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))",
  "color-mix": "color: color-mix(in srgb, red, blue)",
  dvh: "height: 1dvh",
  scale: "scale: 1"
};
export const missingFeatures = () => Object.keys(NEED).filter(k => !CSS.supports(NEED[k]!));
export function Support() {
  const $ = _c(15);
  const [missing] = useState(missingFeatures);
  let t0;
  if ($[0] !== missing) {
    t0 = missing.join(",");
    $[0] = missing;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const key = `support-dismissed:${t0}`;
  let t1;
  if ($[2] !== key || $[3] !== missing.length) {
    t1 = () => !missing.length || !!localStorage.getItem(key);
    $[2] = key;
    $[3] = missing.length;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const [hidden, setHidden] = useState(t1);
  if (hidden) {
    return null;
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span>Update browser</span>;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== missing) {
    t3 = missing.join(" · ");
    $[6] = missing;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <span className="mono">{t3}</span>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== key) {
    t5 = <LinkButton aria-label="Dismiss" onClick={() => {
      localStorage.setItem(key, "1");
      setHidden(true);
    }}>✕</LinkButton>;
    $[10] = key;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <div id="support" data-t="support" role="status">{t2}{t4}{t5}</div>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}